const _ = require('lodash');

module.exports = function ($rootScope, $timeout, $sce, trolleyService, collectionzoneService, deliveryService, breakpointsService, settingsService, shopPageStateService, shopperService, loginService, addressService, moveFocus, featureService, storePickerService) {

    return {
        restrict: 'E',
        scope: {
            orderManagementPanel: '=show'
        },
        link(scope) {
            scope.enableWowRewardsBaseEarnDisplay = false;
            scope.enableWowRewardsTrolleyPreference = false;

            scope.items = {
                trolleyItems: [],
                restrictedItems: [],
                outOfStockItems: []
            };
            scope.trolley = trolleyService;
            scope.collectionzone = collectionzoneService;
            scope.deliveryService = deliveryService;
            scope.addressService = addressService;
            scope.breakpointsService = breakpointsService;
            scope.storePicker = storePickerService;
            scope.redirectUrl = '';
            scope.showDeliveryFeeStructure = false;
            scope.searchInput = {};
            scope.isEnabledSaveforLater = false;

            // check enableSaveforLaterChanges status
            settingsService.getSettingValue('EverydayRewards', 'EnableSaveforLaterChanges').then(function (setting) {
                scope.isEnabledSaveforLater = setting || false;
            });

            const getSettings = () => {
                settingsService.getSettingValue('EverydayRewards', 'CardName').then(function (setting) {
                    scope.RewardsCardName = setting;
                });

                settingsService.getSettingValue('Rebates', 'EnableWowRewardsBaseEarnDisplay').then(function (results) {
                    scope.enableWowRewardsBaseEarnDisplay = results;
                });

                settingsService.getSettingValue('Rebates', 'EnableWowRewardsTrolleyPreference').then(function (results) {
                    scope.enableWowRewardsTrolleyPreference = results;
                });
            };

            getSettings();

            const isRegisteredWowRewardsCustomer = () => {
                return shopperService.currentUser.hasEdrCard;
            };

            const setWowRewardsPref = function (pref) {
                scope.wowRewardsPrefTitle = '';
                scope.wowRewardsPrefIcon = '';

                pref = pref || 'Automatic';

                const wowRewardsPref = [
                    {
                        pref: 'Christmas',
                        icon: 'icon--christmas_tree_small',
                        title: 'Bank for Christmas',
                        title0Balance: 'Saving<br>for Xmas'
                    },
                    {
                        pref: 'Automatic',
                        icon: 'icon--savings-pig-small',
                        title: 'to spend',
                        title0Balance: 'to spend'
                    },
                    {
                        pref: 'QuarterlyQff',
                        icon: 'icon--plane',
                        title: 'Converting to Qantas Points',
                        title0Balance: 'Converting to Qantas Points'
                    },
                    {
                        pref: 'AutomaticSaveForLater',
                        icon: 'icon--savings-pig-small',
                        title: 'to spend',
                        title0Balance: 'to spend'
                    }
                ];

                const selected = _.find(wowRewardsPref,
                    (obj) => {
                        return obj.pref === pref;
                    });

                const title = selected ?
                    scope.trolley.wowRewardsSummary.WowRewardsToSpend > 0
                        ? selected.title
                        : selected.title0Balance
                    : '';
                scope.wowRewardsPrefTitle = $sce.trustAsHtml(title);
                scope.wowRewardsPrefIcon = selected ? selected.icon : '';
            };

            setWowRewardsPref(scope.trolley.wowRewardsSummary.SaveForLaterPreference);

            if (shopperService.OrderCount <= 0) {
                scope.orderManagementPanel.isShowing = false;
            }

            scope.showDeliveryPassPage = function () {
                shopPageStateService.triggerPanel('left', true);
            };

            scope.isGuest = function () {
                return shopperService.currentUser.isGuest;
            };

            scope.clearAll = function () {
                trolleyService.clearTrolley('cart');
                scope.clearDeliveryPassLimitMessage();
            };

            scope.cancelSearch = function () {
                scope.searchInput.searchFilter = '';
            };

            scope.cleanCart = function () {
                trolleyService.cleanTrolleyItems('cart').then(() => {
                    trolleyService.getTrolley();
                });
            };

            scope.showDelivery = function () {
                return deliveryService.isDelivery();
            };

            scope.clearDeliveryPassLimitMessage = function () {
                scope.DeliveryPassQuantityExceeded = false;
            };

            scope.closeCart = function () {
                moveFocus('.header-container');
                shopPageStateService.triggerPanel('right', false);
            };

            scope.$on('login:success', function (ev, loginResult) {
                scope.promptForLogin = false;
                getSettings();
                trolleyService.getTrolley().then(function () {
                    scope.$broadcast('trolley:update', { mergedTrolley: loginResult.MergedGuestTrolley });
                }).then(function () {
                    if (loginResult.HasCollectionZoneMessages) {
                        scope.HasCollectionZoneMessages = true;
                        scope.collectionZoneMessages = loginResult.LoginCollectionZoneMessages;
                        moveFocus('._trolleyMessageContainer1');
                    }
                });
            });

            scope.$on('order-change', function () {
                trolleyService.getTrolley();
            });

            function promptGuestForLogin(loginPromptMessage) {
                scope.promptForLogin = true;
                loginService.loginPromptMessage = loginPromptMessage;
                $timeout(function () {
                    document.getElementById('loginForm-Email').focus();
                }, 0, false);
            }

            scope.$on('save-trolley-as-list-login', function (event, message) {
                promptGuestForLogin(message.message);
            });

            scope.$on('address-update', function () {
                $timeout(function () {
                    trolleyService.trolleyProducts = [];

                    trolleyService.getTrolley();

                    if (shopperService.currentUser.isGuest) {
                        promptGuestForLogin(loginService.LoginToSetDeliveryOrPickupAddressMessage); //'Please login to select your delivery/pick up address'
                    } else {
                        scope.promptForLogin = false;
                    }
                }, 0, true);
            });

            scope.$on('authentication:invalid', function () {
                promptGuestForLogin(loginService.LoginToSetDeliveryOrPickupAddressMessage);
            });

            scope.closeLoginPrompt = function () {
                scope.promptForLogin = false;
                loginService.loginPromptMessage = null;
            };


            scope.toggleDeliveryFeeCard = function () {
                if (scope.showDeliveryFeeStructure) {
                    scope.showDeliveryFeeStructure = false;
                    moveFocus('._deliveryFeeOpenButton');
                } else {
                    scope.showDeliveryFeeStructure = true;

                    moveFocus('._deliveryFeeCloseButton');

                    //get delivery fee structure levels
                    deliveryService.getDeliveryFeeStructure().then(function () {
                        scope.deliveryFeeStructure = deliveryService.deliveryFeeStructure;
                    });
                }
            };

            scope.changeDeliveryWindow = function () {
                deliveryService.triggerDeliveryTimetable();
            };

            scope.filterRestrictedProducts = function (item) {
                return item.IsRestricted && item.IsAvailable;
            };

            scope.itemCount = function () {
                return scope.items.trolleyItems.length + scope.items.restrictedItems.length + scope.items.outOfStockItems.length;
            };

            scope.wowRewardsEarned = function () {
                return scope.trolley.wowRewardsSummary && scope.trolley.wowRewardsSummary.WowRewardsEarned;
            };

            scope.showWowRewardsSummary = () => {
                return scope.enableWowRewardsBaseEarnDisplay && isRegisteredWowRewardsCustomer();
            };

            scope.showWowRewardsPref = () => {
                // Switch must active
                // Should have no errors from LMS
                // When Pref "Automatic" then value must be > 0
                return (scope.enableWowRewardsTrolleyPreference && !scope.trolley.wowRewardsSummary.IsErrorInGettingWowRewardsBalance)
                    && (scope.trolley.wowRewardsSummary.SaveForLaterPreference && ((scope.trolley.wowRewardsSummary.SaveForLaterPreference === 'Automatic' &&
                        scope.trolley.wowRewardsSummary.WowRewardsToSpend > 0) || scope.trolley.wowRewardsSummary.SaveForLaterPreference !== 'Automatic'));
            };

            scope.$watch('trolley.wowRewardsSummary', function (newValue, oldValue) {
                if (newValue && newValue.SaveForLaterPreference !== oldValue.SaveForLaterPreference) {
                    setWowRewardsPref(newValue.SaveForLaterPreference);
                    if (scope.isEnabledSaveforLater && newValue.SaveForLaterPreference === 'Automatic') {
                        setWowRewardsPref('AutomaticSaveForLater');
                    }
                }
            });
        },
        template: require('./collection-zone-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-directive.js
 **/